/** Site Wi-Fi copy. pt → pt-BR, otherwise English. No vue-i18n. */

const EN = {
  'overlay.tooltip': 'Configure site Wi-Fi (requires PIN)',
  'pin.title': 'Configure site Wi-Fi',
  'sheet.title': 'Site Wi-Fi',
  'sheet.unlocked': 'Unlocked · {mm:ss}',
  'sheet.current': 'Current connection',
  'sheet.connectedDetail': 'Connected · {signal} · {ip}',
  'sheet.ethernet': 'Ethernet connected. Wi-Fi restore is not needed.',
  'sheet.restoreOn': 'Automatic restore on',
  'sheet.restoreOff': 'Automatic restore off. No network saved on this player.',
  'sheet.pskSaved': 'Password saved',
  'sheet.restoreHelp': 'If Android loses the network after a power cut, the player adds it back at startup. Nobody has to type the password again.',
  'sheet.signal0': 'None',
  'sheet.signal1': 'Weak',
  'sheet.signal2': 'Fair',
  'sheet.signal3': 'Good',
  'sheet.signal4': 'Strong',
  'action.change': 'Change network or password',
  'action.setup': 'Set up Wi-Fi',
  'action.forget': 'Forget saved network',
  'action.forgetConfirm': 'Forget {ssid}? The player will stop restoring it after power cuts. The current connection stays.',
  'action.androidSettings': 'Android settings',
  'action.cancel': 'Cancel',
  'form.ssid': 'Network name (SSID)',
  'form.ssidHelp': 'Exactly as shown on the router. Case-sensitive.',
  'form.psk': 'Password',
  'form.pskHelp': '8–63 characters (WPA2/WPA3).',
  'form.ssidInvalid': 'Use 1–32 bytes.',
  'form.pskInvalid': 'Use 8–63 characters, or 64 hex digits.',
  'form.show': 'Show',
  'form.hide': 'Hide',
  'form.local': 'The password stays on this player only. It is not sent to Lucimark.',
  'form.submit': 'Save and connect',
  'apply.title': 'Connecting to {ssid}…',
  'apply.step1': 'Network added to Android',
  'apply.step2': 'Associating and authenticating',
  'apply.step3': 'Checking access to Lucimark',
  'apply.step4': 'Saving for automatic restore',
  'error.auth': 'Wrong password',
  'error.notFound': 'Network not found',
  'error.timeout': 'Did not connect in time',
  'error.noInternet': 'Connected, but Lucimark is unreachable',
  'error.dpcRefused': 'Android refused the configuration',
  'error.invalid': 'That network name or password is not valid.',
  'error.unchanged': 'Nothing was changed. The previously saved network ({ssid}) is still the one used for automatic restore.',
  'error.retry': 'Correct and try again',
  'success.title': 'Connected to {ssid}',
  'success.body': 'Network saved on this player. If power fails and Android forgets the Wi-Fi, it will be restored automatically at startup.',
  'success.closes': 'Closes in {s}',
  'success.done': 'Done',
  'notOwner.title': 'Setup from the player is unavailable',
  'notOwner.body': 'To save and restore Wi-Fi on its own, the player must be this device\'s Device Owner. It is not, so Android does not let the app configure networks.',
  'unsupported.title': 'Wi-Fi setup is not in this player yet',
  'unsupported.body': 'Open Android settings to connect. After the next app update, the player can save the network itself.',
  'boot.restoring': 'Restoring saved Wi-Fi',
  'boot.retrying': 'Saved Wi-Fi has not connected yet. Retrying in {s} s. If the router changed, use the service PIN to change the network.'
} as const

const PT = {
  'overlay.tooltip': 'Configurar Wi-Fi do local (pede PIN)',
  'pin.title': 'Configurar Wi-Fi do local',
  'sheet.title': 'Wi-Fi do local',
  'sheet.unlocked': 'Desbloqueado · {mm:ss}',
  'sheet.current': 'Conexão atual',
  'sheet.connectedDetail': 'Conectado · {signal} · {ip}',
  'sheet.ethernet': 'Ethernet conectada. Não é preciso restaurar o Wi-Fi.',
  'sheet.restoreOn': 'Restauração automática ativa',
  'sheet.restoreOff': 'Restauração automática desligada. Nenhuma rede salva neste player.',
  'sheet.pskSaved': 'Senha salva',
  'sheet.restoreHelp': 'Se o Android perder a rede após uma queda de energia, o player a adiciona de novo ao ligar. Ninguém precisa digitar a senha outra vez.',
  'sheet.signal0': 'Nenhum',
  'sheet.signal1': 'Fraco',
  'sheet.signal2': 'Regular',
  'sheet.signal3': 'Bom',
  'sheet.signal4': 'Forte',
  'action.change': 'Alterar rede ou senha',
  'action.setup': 'Configurar Wi-Fi',
  'action.forget': 'Esquecer rede salva',
  'action.forgetConfirm': 'Esquecer {ssid}? O player deixa de restaurá-la após quedas de energia. A conexão atual continua.',
  'action.androidSettings': 'Configurações do Android',
  'action.cancel': 'Cancelar',
  'form.ssid': 'Nome da rede (SSID)',
  'form.ssidHelp': 'Exatamente como aparece no roteador. Diferencia maiúsculas.',
  'form.psk': 'Senha',
  'form.pskHelp': '8 a 63 caracteres (WPA2/WPA3).',
  'form.ssidInvalid': 'Use de 1 a 32 bytes.',
  'form.pskInvalid': 'Use 8 a 63 caracteres, ou 64 dígitos hexadecimais.',
  'form.show': 'Mostrar',
  'form.hide': 'Ocultar',
  'form.local': 'A senha fica só neste player. Não é enviada à Lucimark.',
  'form.submit': 'Salvar e conectar',
  'apply.title': 'Conectando a {ssid}…',
  'apply.step1': 'Rede adicionada ao Android',
  'apply.step2': 'Associando e autenticando',
  'apply.step3': 'Verificando acesso à Lucimark',
  'apply.step4': 'Salvando para restauração automática',
  'error.auth': 'Senha incorreta',
  'error.notFound': 'Rede não encontrada',
  'error.timeout': 'Não conectou a tempo',
  'error.noInternet': 'Conectado, mas sem acesso à Lucimark',
  'error.dpcRefused': 'O Android recusou a configuração',
  'error.invalid': 'Esse nome de rede ou senha não é válido.',
  'error.unchanged': 'Nada foi alterado. A rede salva antes ({ssid}) continua sendo a usada na restauração automática.',
  'error.retry': 'Corrigir e tentar de novo',
  'success.title': 'Conectado a {ssid}',
  'success.body': 'Rede salva neste player. Se faltar energia e o Android esquecer o Wi-Fi, ela será restaurada sozinha ao ligar.',
  'success.closes': 'Fecha em {s}',
  'success.done': 'Concluir',
  'notOwner.title': 'Configuração pelo player indisponível',
  'notOwner.body': 'Para salvar e restaurar o Wi-Fi sozinho, o player precisa ser Device Owner deste aparelho. Aqui não é, então o Android não deixa o app configurar redes.',
  'unsupported.title': 'Esta versão do player ainda não configura o Wi-Fi',
  'unsupported.body': 'Abra as configurações do Android para conectar. Depois da próxima atualização do app, o player pode salvar a rede sozinho.',
  'boot.restoring': 'Restaurando o Wi-Fi salvo',
  'boot.retrying': 'O Wi-Fi salvo ainda não conectou. Nova tentativa em {s} s. Se o roteador mudou, use o PIN de manutenção para alterar a rede.'
} satisfies Record<keyof typeof EN, string>

export type TWifiCopyKey = keyof typeof EN

export function wifiLocale(language?: string): 'en' | 'pt-BR' {
  const lang = (language ?? (typeof navigator === 'undefined' ? 'en' : navigator.language)).toLowerCase()
  return lang.startsWith('pt') ? 'pt-BR' : 'en'
}

export function wifiText(key: TWifiCopyKey, vars?: Record<string, string | number>, language?: string): string {
  const table = wifiLocale(language) === 'pt-BR' ? PT : EN
  let text: string = table[key]
  if (vars) {
    for (const [name, value] of Object.entries(vars)) {
      text = text.replaceAll(`{${name}}`, String(value))
    }
  }
  return text
}
